import { ReactNode } from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';

import { SecretsProvider } from '@/Pages/Playground/PlaygroundHome/PlaygroundSecretsContext';

import { Pane } from '../Pane';

export function EvaluatorCrudPaneLayout(props: {
  title: string;
  left: ReactNode;
  right: ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  header: ReactNode;
}) {
  return (
    <SecretsProvider>
      <Pane
        title={props.title}
        open={props.open}
        onClose={() => props.setOpen(false)}
        className="p-0"
        preventInteractOutside
        topBarRightElement={props.header}
        dialogStyle={{
          marginLeft: '80px',
        }}
      >
        <PanelGroup direction={'horizontal'} className={'h-full'}>
          <Panel
            defaultSize={70}
            minSize={30}
            className="overflow-y-auto p-6 pl-1"
          >
            {props.left}
          </Panel>
          <PanelResizeHandle className="group relative flex items-stretch text-secondary data-[resize-handle-active]:text-brand-green-400">
            <div className="w-[2px] bg-tertiary group-hover:bg-brand-green-400" />
            <div className="absolute inset-y-0 -left-[4px] z-10 w-[9px] opacity-0" />
            <div className="absolute inset-y-0 w-[2px] bg-current opacity-0 transition-all" />
          </PanelResizeHandle>
          <Panel defaultSize={30} minSize={30} className="overflow-y-auto p-6">
            {props.right}
          </Panel>
        </PanelGroup>
      </Pane>
    </SecretsProvider>
  );
}
